<style>
.loader-blue:after {
  content: '';
  display: block;
  width: 17px;
  height: 17px;
  margin: -1px 1px 1px -2px;
  border-radius: 50%;
  border: 2px solid #0083ca;
  border-color: #0083ca transparent #0083ca transparent;
  -webkit-animation: loader 1.2s linear infinite;
  animation: loader 1.2s linear infinite;
}
</style>
<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Boletos</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">POSIÇÃO EM ABERTO</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-xs-12">
                <vue-good-table
                  :columns="columns"
                  :rows="registros"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 20,
                    position: 'top',
                    perPageDropdown: [20, 40, 60],
                    dropdownAllowAll: true,
                    nextLabel: 'Próximo',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Linhas por página',
                    ofLabel: 'de',
                    pageLabel: 'page',
                    allLabel: 'Todos',
                  }"
                  styleClass="vgt-table"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'valor'">{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
                    <span v-else-if="props.column.field == 'nrPedido' && permissions.isFinancial">{{ props.formattedRow[props.column.field] }}</span>

                    <button v-else-if="props.column.field == 'DowLin'" v-on:click="!loading && downloadBoleto(props.row.DowLin)">
                      <i v-show="!loading" class="fa fa-download" aria-hidden="true"></i>
                      <Loader v-show="loading" style="width: 13px; height: 13px" />
                    </button>
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                  <div slot="emptystate">Sem dados para exibição</div>
                </vue-good-table>
                <div class="panel panel-default">
                  <div class="panel-heading" style="text-align: end; font-weight: bold">Total: {{ soma }}</div>
                </div>
                <modal-default title="Boleto" width="90" v-if="showModal" @close="showModal = false"></modal-default>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import 'vue-good-table/dist/vue-good-table.css'

import { VueGoodTable } from 'vue-good-table'
import ModalDefault from './partials/ModalDefault.vue'

export default {
  name: 'TicketPayment',
  components: {
    VueGoodTable,
    ModalDefault,
  },
  data() {
    return {
      showModal: false,
      permissions: {
        isFinancial: true,
      },
      columns: [
        { label: 'Título', field: 'NumTit' },
        { label: 'Nosso Número', field: 'TitBan' },
        { label: 'Vencimento', field: 'DatPpt' },
        { label: 'Valor', field: 'VlrAbe' },
        { label: '2a via', field: 'DowLin' },
      ],
      registros: [],
      soma: 0,
      loading: false,
    }
  },
  mounted() {
    const self = this
    var xhr = new XMLHttpRequest()
    xhr.onload = () => {
      if (xhr.status == 200) {
        let jsonResponse = JSON.parse(xhr.responseText)
        jsonResponse.forEach((element) => {
          const valor = parseFloat(element.VlrAbe)
          const registro = element
          registro.VlrAbe = self.formatCurrency(element.VlrAbe)
          registro.DowLin = `Financeiro.svc/baixar-boleto?codEmp=${element.CodEmp}&codFil=${element.CodFil}&codPor=${element.CodPor}&codCrt=${element.CodCrt}&numTit=${element.NumTit}`

          self.soma += valor
          self.registros.push(registro)
        })

        self.soma = self.formatCurrency(self.soma)
      } else if (xhr.status == 401) {
        swal({
          title: 'É necessário estar logado',
          icon: 'warning',
        }).then(() => (location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href))
      }
    }

    xhr.open('GET', self.$apiUrl + 'Financeiro.svc/retornaboletos')
    xhr.setRequestHeader('Content-type', 'application/json')
    xhr.withCredentials = true
    xhr.send()
  },
  methods: {
    formatCurrency: function (v) {
      //formada coluna de valores da tabela para moeda
      v = v.toString().replace(',', '.')
      var formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      }
      return parseFloat(v).toLocaleString('pt-BR', formato)
    },
    downloadBoleto: async function (url) {
      const self = this
      self.loading = true
      try {
        const fullUrl = `${this.$apiUrl}${url}`
        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        })

        if (response.status === 200) {
          const base64Raw = await response.text()

          const base64String = JSON.parse(base64Raw)
            .replace(/^data:application\/pdf;base64,/, '')
            .replace(/[\r\n]+/g, '')
            .trim()

          const byteCharacters = atob(base64String)
          const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })

          const novaAba = window.open('', '_blank')
          const blobUrl = URL.createObjectURL(blob)

          if (!novaAba) {
            swal({
              title: 'Aba bloqueada pelo navegador',
              text: 'Por favor, permita pop-ups para este site.',
              icon: 'warning',
            })
            return
          }

          novaAba.location.href = blobUrl
        } else if (response.status === 401) {
          await swal({
            title: 'É necessário estar logado',
            icon: 'warning',
          })
          window.location.href = `${this.$SiteUrl}/login?redirectTo=${window.location.href}`
        } else {
          swal({
            title: 'Erro ao baixar boleto',
            text: `Código ${response.status}`,
            icon: 'error',
          })
        }
      } catch (error) {
        console.error('Erro ao abrir PDF:', error)
        swal({
          title: 'Erro inesperado',
          text: error.message,
          icon: 'error',
        })
      } finally {
        self.loading = false
      }
    },
  },
}
</script>
